import React__default from 'react';
import { Link } from '@amzn/storm-ui';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-BLE3wELi-CV9fXVbx.js';

const ManageCountryListLink = ({
  href
}) => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React__default.createElement(Link, {
    href: href,
    size: "base"
  }, formatMessage({
    id: 'manage-country-list-link'
  }));
};

export { ManageCountryListLink as M };
//# sourceMappingURL=ManageCountryListLink-7qog4ed0.js.map
